export const scrollToTop = () => {
  const siteNav = document.querySelector("#site-header");
  if (siteNav) {
    window.scrollTo(0, siteNav.getBoundingClientRect().height);
  }
};

export const scrollToWithOffset = (selector: string, offset: number) => {
  const $element = $(selector);
  if ($element.length) {
    // @ts-ignore
    window.scrollTo({
      left: 0, 
      // @ts-ignore
      top: $element.offset().top + offset,
      behavior: "smooth"
    });
  }
};

export const getPriceFormatted = (price: number | undefined): string => {
  if (price === undefined) {
    return "";
  } else if (price === 0) {
    return "Included";
  } else {
    return "$" + price.toLocaleString();
  }
};

export const getHtmlFromSvg = async (url: string): Promise<string> => {
  if(url){
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status} - ${url}`);
      }
      return await response.text(); // The SVG content is an XML string
    } catch (error) {
      console.error(`Failed to fetch SVG: ${url}`, error);
      return ""; // Return an empty string in case of an error
    }
  }else{
    return "";
  }
};
